(function() {
    'use strict';

    var formData;
    var firstClickForm = false;
    var category;

    if (document.body.classList.contains('template--contact')) {
        category = 'Contact form';

        window.addEventListener('message', function() {

            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
                formStart();

                var form = document.querySelector('.hs-form');

                if (form) {
                    form.addEventListener('click', formClick);
                }
            }

            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
                formData = event.data.data;
            }

            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
                formSubmitted();
            }
        });
    }

    if (document.body.classList.contains('template--event')) {
        category = 'Event form';

        window.addEventListener('message', function() {

            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
                formStart();

                var form = document.querySelector('.hs-form');

                if (form) {
                    form.addEventListener('click', formClick);
                }
            }

            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
                formData = event.data.data;
            }

            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
                formSubmitted();
            }
        });
    }

    if (document.body.classList.contains('template--whitepaper')) {
        category = 'Whitepaper';

        window.addEventListener('message', function() {

            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
                formStart();

                var form = document.querySelector('.hs-form');

                if (form) {
                    form.addEventListener('click', formClick);
                }
            }

            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
                formData = event.data.data;
            }

            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
                formSubmitted();
            }
        });
    }

    function formStart() {
        dataLayer.push({
            "object": {
                "Id": "OBJ003",
                "name": "Form - View"
            },
            "gaStep": {
                "value": "1-form-view"
            },
            "form": {
                "category": category
            }
        });
    }

    function formClick() {
        if (!firstClickForm) {
            dataLayer.push({
                "object": {
                    "Id": "OBJ004",
                    "name": "Form - Start"
                },
                "event": "VPV",
                "gaStep": {
                    "value": "2-form-start"
                },
                "form": {
                    "category": category
                }
            });

            firstClickForm = true;
        }
    };

    function formSubmitted() {
        dataLayer.push({
            "object": {
                "Id": "OBJ005",
                "name": "Form - Sent"
            },
            "event": "VPV",
            "gaStep": {
                "value": "3-form-sent"
            },
            "form": {
                "category": category,
                "fields": formData
            }
        });
    }

})();
